import React from "react";

import ConfirmationModalMessage from "../components/ConfirmationModalMessage";
import {
  BDP_FLOW,
  HDP_BASIC_FLOW,
  HDP_FULL_FLOW,
  HDP_LISTING_AGENT_FLOW,
  HDP_MESSAGE_SCREENING_FLOW,
  HDP_POST_SUBMIT_FLOW
} from "../constants/flows";
import { BUY_OR_SELL } from "../constants/formTypes";

const determineConfirmationScenario = ({
  building,
  contactFormType,
  currentFlow,
  expert,
  listing
}) => {
  const confirmationScenarios = {
    [BDP_FLOW]: {
      confirmationHeader: null,
      confirmationText: `We passed your note about ${building.address.pretty_address} on to ${expert.contact.name}`
    },
    [BUY_OR_SELL]: {
      confirmationHeader: "Message Sent!",
      confirmationText: `Your message is on its way to ${expert.contact.name}. Expect a confirmation email from us shortly with what's next.`
    },
    [HDP_BASIC_FLOW]: {
      confirmationHeader: null,
      confirmationText: `We passed your note about ${listing?.address.pretty_address} ${listing?.address.unit} on to ${expert.contact.name}`
    },
    [HDP_FULL_FLOW]: {
      confirmationHeader: "Message Sent",
      confirmationText: (() => (
        <ConfirmationModalMessage agentName={expert.contact.name} />
      ))()
    },
    [HDP_LISTING_AGENT_FLOW]: {
      confirmationHeader: "Message Sent",
      confirmationText: (() => (
        <ConfirmationModalMessage agentName={listing?.contacts[0].name} />
      ))()
    },
    [HDP_MESSAGE_SCREENING_FLOW]: {
      confirmationHeader: "Message Sent",
      confirmationText: (() => (
        <ConfirmationModalMessage agentName={expert.contact.name} />
      ))()
    },
    [HDP_POST_SUBMIT_FLOW]: {
      confirmationHeader: null,
      confirmationText: `We passed your note about ${listing?.address.pretty_address} ${listing?.address.unit} on to ${expert.contact.name}`
    }
  };

  const scenario =
    contactFormType === BUY_OR_SELL ? contactFormType : currentFlow;

  return confirmationScenarios[scenario];
};

export default determineConfirmationScenario;
